import { textAccentClass } from '../lib/ui';

interface Props {
  label: string;
  value: string;
  sub?: string;
  accent?: string;
  icon?: string;
}

export default function KpiCard({ label, value, sub, accent = 'mbc-orange', icon }: Props) {
  const accentClass = textAccentClass(accent);

  return (
    <div className="card kpi p-5">
      <div className="flex items-center justify-between">
        <span className="text-[11px] uppercase tracking-wider text-mbc-mute">{label}</span>
        {icon && <span className="text-lg">{icon}</span>}
      </div>
      <div className={`text-2xl font-extrabold mt-2 tabular-nums ${accentClass}`}>
        {value}
      </div>
      {sub && <div className={`text-xs mt-1 ${accentClass}`}>{sub}</div>}
    </div>
  );
}
